import './set_refuse_reason.css'
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import swal from "sweetalert";
import CircularProgress from '@mui/material/CircularProgress';

import { refuse_bill, refuse_request_order_bill, refuse_contract_bill } from '../../../../services/finance_service';
import { refuse_request_order_bill_byPurchaseService } from '../../../../services/purchase_service';


function Set_refuse_reason({ open_reason_modal, setOpen_reason_modal, id_submission, request_code, id_contract, bills_numbers, markets, setMarkets }) {


  const [errorText, setErrorText] = useState("");
  const [waiting, setWaiting] = useState(false);

  const [reason, setReason] = useState('');


  function submit_refuse_reason() {
    setErrorText("");
    if (reason == '') {
      setErrorText("Champ vide !");
    } else {
      swal({
        title: "Etes-vous sûr ?",
        text: "!!!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            setWaiting(true);
            let formData = new FormData();
            if (request_code) formData.append('request_code', request_code);
            else if (id_contract) formData.append('id_contract', id_contract);
            formData.append('bills_numbers', JSON.stringify(bills_numbers));
            formData.append('refuse_reason', reason);
            if (request_code) {
              refuse_request_order_bill_byPurchaseService(formData).then((response) => {
                let tmp_array = [...markets];
                tmp_array[open_reason_modal].bills = response.data;
                setMarkets(tmp_array);
                setOpen_reason_modal(null);
                setWaiting(false);
              }).catch((error) => {
                setWaiting(false);
                //console.log(error.response);
              })
            }
            if (id_contract) {
              refuse_contract_bill(formData).then((response) => {
                let tmp_array = [...markets];
                tmp_array[open_reason_modal].bills = response.data;
                setMarkets(tmp_array);
                setOpen_reason_modal(null);
                setWaiting(false);
              }).catch((error) => {
                setWaiting(false);
                //console.log(error.response);
              })
            }
          }
        })

    }

  }



  return (
    <Dialog className="set_refuse_raison_container" fullWidth={true} maxWidth={'md'} open={open_reason_modal != null ? true : false} onClose={() => setOpen_reason_modal(null)} aria-labelledby="form-dialog-title" >
      <DialogTitle id="form-dialog-title">Motif du rejet</DialogTitle>
      <DialogContent>
        <div>
          {
            errorText == ""
              ? <></>
              : <p className={errorText ? "error" : "valid-champ"}>
                {errorText}
              </p>
          }

          <div style={{ width: "100%", marginTop: "5px" }} >
            <TextField
              id="outlined-multiline-flexible"
              label="Motif"
              variant='outlined'
              multiline
              minRows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className='dialogBottom'>
          <div>
            {
              errorText === ""
                ? <></>
                : <p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                  {errorText}
                </p>
            }
          </div>
          <div>
            <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={() => setOpen_reason_modal(null)} >
              Annuler
            </Button>
            <Button variant="contained" className="submit_but valide_but" startIcon={<SendIcon />} onClick={submit_refuse_reason} >
              Envoyer
            </Button>
          </div>
        </div>
      </DialogActions>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={waiting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  )
}

export default Set_refuse_reason
